import DeleteTemplateDialog from "./deleteTemplateDialog.container";
export default DeleteTemplateDialog;
